import Vue from 'vue'

import { app, data } from '@/cmsCategories/config/selectors'
import { getJsonData } from '@/common/utils/dom'

import Sidebar from '@/top/components/Sidebar.vue'
import FacetsLink from '@/common/components/facets/FacetsLink.vue'
import { initFavoriteBtn, initFavoriteBtnPopup } from '@/common/utils/favorite'
import { BQ_EVENT_NAMES, raksulBQEventTracker } from '@/common/utils'

const initSidebar = () => {
  const mountEl = document.querySelector(app.sidebarMountEl)
  // eslint-disable-next-line @typescript-eslint/ban-types
  const productCategories: Array<object> = getJsonData(data.productCategories)

  if (!mountEl) {
    return
  }

  new Vue({
    render: h => h(Sidebar, { props: { productCategories } })
  }).$mount(mountEl)
}

const initFacets = () => {
  const mountEl = document.querySelector(app.cmsCategoriesFacets)
  if (!mountEl) {
    return
  }
  new Vue({
    render: h => h(FacetsLink)
  }).$mount(mountEl)
}

const initNewCMSCategoryUIABTesting = () => {
  window.triggerNewCMSCategory = () => {
    const styleId = 'newCMSCategoryABTestingStyle'
    const existingStyleEle = document.getElementById(styleId)
    if (existingStyleEle) {
      existingStyleEle.remove()
    }
    const style = document.createElement('style')
    style.id = styleId
    style.innerText = `
      .new-cms-category-ui {
        display: block !important;
      }
      .new-cms-category-ui-suffix {
        display: inline !important;
      }
      .old-cms-category-ui {
        display: none !important;
      }
    `
    document.body.appendChild(style)
    window.isKarteEventTriggered = true
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.DISPLAY_NEW_CMS_CATEGORY,
        data: {}
      })
  }
  if (window.isKarteLoaded) {
    window.triggerNewCMSCategory()
  } else {
    window.isKarteLoaded = false
  }
}

initSidebar()
initFacets()
initFavoriteBtn(app.favoriteButtonMountEl)
initFavoriteBtnPopup(app.favoriteButtonPopupMountEl)
initNewCMSCategoryUIABTesting()
